import * as ActionTypes from './actionTypes';

export function setOrganization(id) {
  return {
    type: ActionTypes.SET_CURRENT_ORGANIZATION,
    id,
  };
}

export function setLoadingScene(sceneId) {
  return {
    type: ActionTypes.EDITOR_SET_LOADING_SCENE,
    sceneId,
  };
}

export function setSceneLoaded(sceneId) {
  return {
    type: ActionTypes.EDITOR_SET_SCENE_LOADED,
    sceneId,
  };
}

export function focusEditorPanel(panel) {
  return {
    type: ActionTypes.EDITOR_FOCUS_PANEL,
    panel,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/editor.js